/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import './customModal.css';
import alertaExito from '../../img/exito.png';
import alertaError from '../../img/erroralerta.png';
import alertaInfo from '../../img/infoalert.png';
import { CustomModalProps } from '../../interfaces/Modals';
import ModalTemplate from './ModalTemplate/ModalTemplate';


const CustomModal: React.FC<CustomModalProps> = (props) => {
  //se crean los modales de acuerdo a las propiedades que se envian
  return (
    <>
      {props.show && (
        <ModalTemplate
          headerMessage='CONTRATO FIRMADO'
          modalImg={alertaExito}
          intermediateMessage='¡Genial! El proceso se ha finalizado correctamente'
          finalMessage='Te hemos enviado una copia del contrato suscrito a tu correo electrónico'
        />
      )}
      {props.firmado && (
        <ModalTemplate
          headerMessage='CONTRATO FIRMADO'
          modalImg={alertaInfo}
          intermediateMessage='Contrato ya firmado'
          finalMessage='El contrato ya fue firmado'
        />
      )}
      {props.error && (
        <ModalTemplate
          headerMessage='ERROR FIRMA'
          modalImg={alertaError}
          intermediateMessage='No se ha podido iniciar el proceso de forma correcta'
          finalMessage='Se ha producido un error en el proceso de firma'
        />
      )}
      {props.anu && (
        <ModalTemplate
          headerMessage='FIRMA ANULADA'
          modalImg={alertaInfo}
          intermediateMessage='No se ha podido iniciar el proceso de forma correcta'
          finalMessage='La firma a la que se intenta acceder está anulada'
        />
      )}
      {props.can && (
        <ModalTemplate
          headerMessage='FIRMA CANCELADA'
          modalImg={alertaInfo}
          intermediateMessage='Se cancela el proceso de firma'
          finalMessage='El proceso de firma electrónica se acaba de cancelar'
        />
      )}
      {props.canNow && (
        <ModalTemplate
          headerMessage='FIRMA CANCELADA'
          modalImg={alertaInfo}
          intermediateMessage='No se ha podido iniciar el proceso de firma'
          finalMessage='La firma a la que se intenta acceder está cancelada'
        />
      )}
    </>
  );
};

export default CustomModal;